export default __webpack_public_path__ + "static/media/ABC.a187c214.png";